export function createSynthPlaybackScope(viewMode, activeTrackIndex = 0) {
  if (viewMode === 'track') return { type: 'track', trackIndex: activeTrackIndex }
  if (viewMode === 'composer') return { type: 'composer', enabledTrackIndices: Array.isArray(activeTrackIndex) ? activeTrackIndex : [] }
  return { type: 'song' }
}

export function getSynthPlaybackTrackEntries(synth, scope = { type: 'song' }) {
  const entries = (synth?.tracks ?? []).map((track, trackIndex) => ({ track, trackIndex }))
  if (scope?.type === 'track') return entries.filter(entry => entry.trackIndex === scope.trackIndex)
  if (scope?.type === 'composer') return entries
  return entries.filter(entry => entry.track.enabled)
}

export function getSynthTrackVisualEntries(synth, activeTrackIndex) {
  return (synth?.tracks ?? [])
    .map((track, trackIndex) => ({ track, trackIndex }))
    .filter(entry => entry.track.enabled || entry.trackIndex === activeTrackIndex)
}
